import { render, staticRenderFns } from "./OrganizarPosicao.vue?vue&type=template&id=a55ba054"
import script from "./OrganizarPosicao.vue?vue&type=script&lang=js"
export * from "./OrganizarPosicao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports